/* eslint-disable */
import * as types from '../../actions/types';

const initialState = {
  list: null,
  current: null,
  loading: false
};

export default function questions (state = initialState, action) {
  switch (action.type) {
    
    case types.SET_TESTING_QUESTIONS_LIST:
      return {
        ...state,
        list: action.payload
      };
    
    case types.SET_TESTING_QUESTIONS_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    
    case types.SET_TESTING_QUESTIONS_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}